module.exports = "https://static.wmbcdn.com/uniweb/images/d4270d61eebe26d1c2301b01a1acb217.svg";